export enum DialogMessageType {
  REQUEST_SLIDE_IMAGES = "REQUEST_SLIDE_IMAGES",
  OPEN_PLACEHOLDER = "OPEN_PLACEHOLDER",
  CLOSE_PLACEHOLDER = "CLOSE_PLACEHOLDER",
  CLOSE_PLACEHOLDER_ALPHA_AGENT = "CLOSE_PLACEHOLDER_ALPHA_AGENT",
  CLOSE_PLACEHOLDER_ALPHA_AGENT_EDIT = "CLOSE_PLACEHOLDER_ALPHA_AGENT_EDIT",
  CLOSE_PLACEHOLDER_PLACEHOLDER_POPUP = "CLOSE_PLACEHOLDER_PLACEHOLDER_POPUP",
  CLOSE = "CLOSE",
  INSERT_CHART = "INSERT_CHART",
  EXTRACT_SLIDES = "EXTRACT_SLIDES",
  CHAT_CLOSE = "CHAT_CLOSE",
  OPEN_PLACEHOLDER_ALPHA_CREATE = "OPEN_PLACEHOLDER_ALPHA_CREATE",
  CLOSE_CONTENT_MANAGER_OPEN_ALPHA_EDIT = "CLOSE_CONTENT_MANAGER_OPEN_ALPHA_EDIT",
  CLOSE_CONTENT_MANAGER_OPEN_PLACEHOLDER_UPDATE_POPUP = "CLOSE_CONTENT_MANAGER_OPEN_PLACEHOLDER_UPDATE_POPUP",
  CONTENT_MANAGER_REFRESH = "CONTENT_MANAGER_REFRESH",
  OPEN_CONFIRM_PLACEHOLDER = "OPEN_CONFIRM_PLACEHOLDER",
  CLOSE_CONFIRM_PLACEHOLDER = "CLOSE_CONFIRM_PLACEHOLDER",
  INSERT_DATA_TO_PLACEHOLDER = "INSERT_DATA_TO_PLACEHOLDER",
  OPEN_CONTENT_READY_SLIDES = "OPEN_CONTENT_READY_SLIDES",
}

export interface DialogMessage {
  action: DialogMessageType;
  data?: any;
}
